import filter from 'lodash/filter';
import upperCase from 'lodash/upperCase';
import { getBasketQuantity } from './basket';
import WalletService from './walletService';

export const prepareTrackingData = ({
  basketProducts,
  order,
  orderSummary,
  paymentData,
  type,
}) => {
  const data = {
    cardType: type,
    currency: orderSummary.currency,
    productOrder: order.productOrder,
    quantity: getBasketQuantity(basketProducts),
    walletAmountUsed: paymentData.walletAmount,
  };

  return {
    config: { data: JSON.stringify(paymentData) },
    data,
  };
};

export const getWalletAmount = async (orderSummary) => {
  const response = await WalletService.getWallet();
  const userWallets = filter(response.data, (wallet) => {
    return wallet.currency === upperCase(orderSummary.currency);
  });

  return userWallets[0].balance;
};

export const getDeliveryOptionType = ({ product, orderSummary }) => {
  return product.deliveryOptionType && !orderSummary.postageOnRedemption
    ? Object.prototype.hasOwnProperty.call(
        product.deliveryOptionType,
        'deliveryOptionType',
      )
      ? product.deliveryOptionType.deliveryOptionType
      : product.deliveryOptionType
    : null;
};

export const getOrderLinesPayload = ({ deliveryOptionType, product }) => {
  return {
    dealVoucherProductId: product.payDeposit
      ? product.depositProduct.id
      : product.id,
    deliveryOptionType,
    gift: product.gift,
    gifting: product.gifting,
    giftPack: product.giftPack,
    giftWrap: product.giftWrap,
    orderAddons: product.orderAddons,
    quantity: product.quantity,
  };
};

export const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
